module.exports = __webpack_public_path__ + "media/icons/slider-point-a4ea250a.png";